export default __webpack_public_path__ + "static/media/Matsal5.08e4be85.jpeg";